// removed by extract-text-webpack-plugin
module.exports = {"icon":"QUlHw","heading":"_2kEOh","itemContainer":"TFqZO","wrapper":"_1w6pS","ownsService":"_34ovy","itemInfoMain":"_3Fx9V","itemInfoSecondary":"ZS2UQ","editButton":"_1keuu"};


//////////////////
// WEBPACK FOOTER
// ./components/OrderSummaryItem/styles.scss
// module id = 691
// module chunks = 0